export default __webpack_public_path__ + "224fcd2e87ca1bbc53b9934fbea7e570.png";